import Member from 'iam/models/Member'
import Message from './Message'

/**
 * Message status.
 */
export interface MessageStatus {
  id: string
  message: Message
  member: Member
  deliveryStatus: MessageDeliveryStatus
}

/**
 * Message delivery status.
 */
export enum MessageDeliveryStatus {
  /**
   * No status.
   */
  None,
  /**
   * Message was sent.
   */
  Sent,
  /**
   * Message was delivered.
   */
  Delivered,
  /**
   * Message was read.
   */
  Read,
}
